<section class="deam-root">
  <div class="deam-top-navbar">
    <app-workflow-topbar [data]="topbar"></app-workflow-topbar>
  </div>
  <main
    class="master-detail-layout"
    [class.sidebar-collapsed]="sidebarCollapsed"
  >
    <app-side-panel-card-list
      title="DEAM Service"
      [subtitle]="entities.length + ' entities available'"
      [items]="sidePanelItems"
      [activeId]="selectedId || ''"
      [collapsed]="sidebarCollapsed"
      [selectOnHover]="true"
      [showAddAction]="!loading && !loadError"
      addLabel="Add Entity"
      (select)="selectEntity($event)"
      (addCatalog)="openAddEntity()"
    ></app-side-panel-card-list>
    <div *ngIf="loading" role="status">Loading entities...</div>
    <div *ngIf="loadError" role="alert">
      {{ loadError }}
      <button type="button" (click)="loadEntities()">Retry</button>
    </div>
    <app-entity-detail-accordion
      class="master-detail-surface"
      *ngIf="!loading && !loadError"
      [entities]="entities"
      [selectedId]="selectedId"
      [isSidebarCollapsed]="sidebarCollapsed"
      [saveStatus]="saveStatus"
      (entitiesChange)="updateEntities($event)"
      (saveEntity)="save($event)"
      (toast)="showToast($event)"
      (sidebarCollapsedChange)="sidebarCollapsed = $event"
    ></app-entity-detail-accordion>
  </main>
  <div
    class="toast"
    [class.visible]="toastVisible"
    role="status"
    aria-live="polite"
  >
    {{ toastVisible ? toastMessage : "" }}
  </div>
</section>
